import { MenuPagesResponse } from './AppData';

// Temporary production fallback while the menu API is unavailable.
const menuPagesUrl = `${process.env.PUBLIC_URL}/menupages.json`;

export const getData = async (): Promise<MenuPagesResponse> => {
	const res = await fetch(menuPagesUrl, {
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	});

	return res.json(); // promise
};
